import React, { useState } from "react";

const Popover = ({ adults, setAdults, children, setChildren, infants, setInfants, callby, flight_class, setFlightClass }) => {
    const [isOpen, setIsOpen] = useState(false);

    // Toggle the visibility of the popover
    const togglePopover = () => {
        setIsOpen(!isOpen);
    };

    // Close the popover when clicking outside
    const closePopover = (e) => {
        const popoverContainer = document.getElementById('containerpopver');
        if (popoverContainer && e.target.id != 'popoverTrigger' && !popoverContainer.contains(e.target) && isOpen) {
            setIsOpen(false);
        }
    };

    // Add event listener for clicks outside the popover
    React.useEffect(() => {
        document.addEventListener('click', closePopover);
        return () => {
            document.removeEventListener('click', closePopover);
        };
    }, [isOpen]);

    const cabinClasses = ['economy', 'premium economy', 'business', 'first'];

    return (
        <div className="relative inline-block text-left w-full">
            {/* Hidden trigger button */}
            <button
                type="button"
                id="popoverTrigger"
                onClick={togglePopover}
                className="hidden"
                aria-label="Open passengers menu"
            />
            {isOpen && (
                <div 
                    className="popover-container absolute mt-2 w-[82vw] md:w-[400px] bg-white border border-gray-300 rounded-md shadow-lg z-50" 
                    id="containerpopver"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="py-2 px-4 text-gray-800 space-y-3">
                        <PassengerTypeSections passenger={adults} setPassenger={setAdults} text1={`Adults`} text2={`18 +`} />
                        <PassengerTypeSections passenger={children} setPassenger={setChildren} text1={`Children`} text2={`Under 18 and Above 2`} />
                        <PassengerTypeSections passenger={infants} setPassenger={setInfants} text1={`Infants`} text2={`Under 2`} />
                        
                        {/* Cabin Class Selection */}
                        {flight_class !== undefined && setFlightClass && (
                            <div className="border-t border-gray-200 pt-3 mt-3">
                                <p className="font-bold text-[16px] mb-2">Cabin Class</p>
                                <div className="space-y-2">
                                    {cabinClasses.map((cabin) => (
                                        <label 
                                            key={cabin}
                                            className="flex items-center cursor-pointer"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <input
                                                type="radio"
                                                name="cabinClass"
                                                value={cabin}
                                                checked={flight_class === cabin}
                                                onChange={(e) => {
                                                    e.stopPropagation();
                                                    setFlightClass(e.target.value);
                                                }}
                                                className="mr-2"
                                            />
                                            <span className="text-[16px] capitalize">{cabin}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};



const PassengerTypeSections = ({ passenger, setPassenger, text1, text2 }) => {
    return (
        <div className="flex gap-5 justify-between">
            <div className="basis-2/3">
                <p className="font-bold text-[16px]">{text1}</p>
                <p className=" text-[16px]">{text2}</p>
            </div>
            <div className="flex justify-center items-center">
                <button 
                    type="button"
                    className="bg-black text-white h-[30px] w-[30%] rounded-md font-bold" 
                    onClick={(e) => {
                        e.stopPropagation();
                        if (!isNaN(passenger))
                            setPassenger(passenger + 1);
                    }}
                >
                    +
                </button>
                <input 
                    type="text" 
                    className="w-[40%] h-[30px] text-center" 
                    value={passenger} 
                    onChange={(e) => {
                        e.stopPropagation();
                        if (!isNaN(e.target.value)) {
                            setPassenger(e.target.value)
                        }
                    }}
                    onClick={(e) => e.stopPropagation()}
                />
                <button 
                    type="button"
                    className="bg-black text-white h-[30px] w-[30%] rounded-md font-bold" 
                    onClick={(e) => {
                        e.stopPropagation();
                        if (!isNaN(passenger) && passenger >= 1)
                            setPassenger(passenger - 1);
                    }}
                >
                    -
                </button></div>

        </div>
    )
}

export default Popover;
